export default __webpack_public_path__ + "static/vifon-prazynki-e163bb7d908a89ca0450935b4d5fb425.png";